import { Typography } from "@mui/material";
import React from "react";
import { useStyles } from "../Common/CommonStyle";
import DialogBox from "../Common/DialogBox";
import LinearProgressBar from "../Common/LinearProgressBar";
import VideoPlayer from "../Common/VideoPlayer";

export interface ICustomDeleteProcess {
  displayNextSlide: () => void;
  type: number;
}
const CustomDeleteProcess = (props: ICustomDeleteProcess) => {
  const classes = useStyles();
  const [nextSlide, showNextSlide] = React.useState(0);
  const [progressComplete, setProgressComplete] = React.useState(0);

  const statusComplete = () => {
    setProgressComplete(progressComplete + 1);
  };

  React.useEffect(() => {
    if (progressComplete === 1) props.displayNextSlide();
  }, [progressComplete]);

  const preventiveProgressScan = (
    <div
      style={{
        flexDirection: "column",
        display: "flex",
        justifyContent: "space-evenly",
        alignItems: "center",
        height: "inherit",
        width: "inherit",
      }}
    >
      <Typography
        variant="body2"
        sx={{ color: "#fff", marginTop: "2.5rem", fontWeight: 600 }}
      >
        Deleting malicious code...
      </Typography>
      <LinearProgressBar
        message={""}
        statusComplete={statusComplete}
        timeInterval={500}
        typoSize={2}
      />
    </div>
  );
  return (
    <div
      className={classes.positionComponent}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <VideoPlayer
        videoURL={"asset/video/ScanningProgressVideo.mp4"}
        styles={{
          position: "absolute",
          left: "27%",
          top: "8rem",
          marginTop: "0rem",
          height: "55%",
          width: "70%",
        }}
        displayNextSlide={() => {}}
      />
      <DialogBox childProps={preventiveProgressScan} type={5}></DialogBox>
    </div>
  );
};

export default CustomDeleteProcess;
